/* global window */
import React from 'react'
import path from 'path'
import PropTypes from 'prop-types'

const ASSET_URL = process.env.STAGING_ENV
  ? 'https://apprentus-staging.twic.pics'
  : 'https://apprentus-uploads.twic.pics'

export function retinaSrc (src) {
  if (!src) {
    return `${ASSET_URL}/assets/design/default_avatar.png`
  }
  let basename = path.basename(src, path.extname(src))
  basename = basename + '@2x' + path.extname(src)
  return src.replace(path.basename(src), basename)
}

export function isRetina () {
  return typeof window !== 'undefined' && window.devicePixelRatio >= 2
}

export function assetUrl (src) {
  if (src.indexOf('/') === 0) {
    return ASSET_URL + src
  }
  return src
}

const Img = ({ src, alt, retina, ...props }) => {
  return <img src={assetUrl(isRetina() ? retina || retinaSrc(src) : src)} alt={alt} {...props} />
}

Img.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  retina: PropTypes.string
}

export default Img
